import { EventEmitter, SimpleChanges } from '@angular/core';
import { MessageService } from '../../message/message.service';
import { SessionStorageService } from 'ngx-webstorage';
import { DomSanitizer } from '@angular/platform-browser';
import { TrackerService } from '../../../core/tracker/tracker.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { User } from '../../../core/user/user.model';
import { STATUS_DISPLAYED_ON_RECEIVER } from '../../../shared/model/message.model';
import { OfflineMessageService } from '../offline-message/offline-message.service';
import { Conversationn } from '../../../shared/model/conversationn.model';
import { JhiLanguageService } from '../../../ng-jhipster/language';
import { JhiEventManager } from '../../../ng-jhipster/service';
import { AccountService } from '../../../core/auth/account.service';
import { BaseChatUIComponent } from '../../session/chat-ui/chat-ui.component';
import { Router } from "@angular/router";
import { Session } from '../../../shared/model/session.model';
import { AuthServerProvider } from '../../../core/auth/auth-jwt.service';
import { Linkify } from '../../../core/util/linkify';
import * as i0 from "@angular/core";
import * as i1 from "../../../ng-jhipster/service";
import * as i2 from "../../message/message.service";
import * as i3 from "ngx-webstorage";
import * as i4 from "../../../core/auth/account.service";
import * as i5 from "../../../core/tracker/tracker.service";
import * as i6 from "@angular/platform-browser";
import * as i7 from "@ng-bootstrap/ng-bootstrap";
import * as i8 from "../offline-message/offline-message.service";
import * as i9 from "../../../ng-jhipster/language";
import * as i10 from "@angular/router";
import * as i11 from "../../../core/auth/auth-jwt.service";
import * as i12 from "angular2-multiselect-dropdown";
import * as i13 from "@angular/common";
import * as i14 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i15 from "@fortawesome/angular-fontawesome";
import * as i16 from "../../../shared/auto-direction-switch/input-auto-direction-switch.directive";
import * as i17 from "@ngx-translate/core";
function OfflineMessageUiComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵelement(2, "small");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 9);
    i0.ɵɵelement(4, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function OfflineMessageUiComponent_div_5_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.showDateBetweenNow(m_r5), "");
} }
function OfflineMessageUiComponent_div_5_div_4_fa_icon_6_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fa-icon", 33);
    i0.ɵɵlistener("click", function OfflineMessageUiComponent_div_5_div_4_fa_icon_6_Template_fa_icon_click_0_listener() { i0.ɵɵrestoreView(_r22); const m_r5 = i0.ɵɵnextContext(2).$implicit; const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.addToMessagesEmail(m_r5, ctx_r20.isCoachAccount); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "inukaNgApp.offlineMessage.selected"));
} }
function OfflineMessageUiComponent_div_5_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵelementStart(2, "div", 30);
    i0.ɵɵelementStart(3, "fa-icon", 31);
    i0.ɵɵlistener("click", function OfflineMessageUiComponent_div_5_div_4_Template_fa_icon_click_3_listener() { i0.ɵɵrestoreView(_r25); const m_r5 = i0.ɵɵnextContext().$implicit; const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.replyThisMessage(m_r5); });
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 30);
    i0.ɵɵtemplate(6, OfflineMessageUiComponent_div_5_div_4_fa_icon_6_Template, 2, 3, "fa-icon", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(4, 2, "inukaNgApp.offlineMessage.reply"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r9.isCoach());
} }
function OfflineMessageUiComponent_div_5_div_5_fa_icon_6_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fa-icon", 33);
    i0.ɵɵlistener("click", function OfflineMessageUiComponent_div_5_div_5_fa_icon_6_Template_fa_icon_click_0_listener() { i0.ɵɵrestoreView(_r29); const m_r5 = i0.ɵɵnextContext(2).$implicit; const ctx_r27 = i0.ɵɵnextContext(); return ctx_r27.addToMessagesEmail(m_r5, ctx_r27.isCoachAccount); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "inukaNgApp.offlineMessage.selected"));
} }
function OfflineMessageUiComponent_div_5_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 34);
    i0.ɵɵelementStart(2, "div", 30);
    i0.ɵɵelementStart(3, "fa-icon", 31);
    i0.ɵɵlistener("click", function OfflineMessageUiComponent_div_5_div_5_Template_fa_icon_click_3_listener() { i0.ɵɵrestoreView(_r32); const m_r5 = i0.ɵɵnextContext().$implicit; const ctx_r30 = i0.ɵɵnextContext(); return ctx_r30.replyThisMessage(m_r5); });
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 30);
    i0.ɵɵtemplate(6, OfflineMessageUiComponent_div_5_div_5_fa_icon_6_Template, 2, 3, "fa-icon", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(m_r5.senderId === ctx_r10.sessionStorage.retrieve("id") ? ctx_r10.floatLeft : ctx_r10.floatRight);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(4, 4, "inukaNgApp.offlineMessage.reply"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r10.isCoach());
} }
function OfflineMessageUiComponent_div_5_div_7_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 37);
} }
function OfflineMessageUiComponent_div_5_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, OfflineMessageUiComponent_div_5_div_7_fa_icon_1_Template, 1, 0, "fa-icon", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.isCoach() && m_r5.chosenToBeEmailed);
} }
function OfflineMessageUiComponent_div_5_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵlistener("click", function OfflineMessageUiComponent_div_5_div_9_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r38); const m_r5 = i0.ɵɵnextContext().$implicit; const ctx_r36 = i0.ɵɵnextContext(); return ctx_r36.scrollToOriginal(m_r5.replyId); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r12.getReplyMessage(m_r5.replyId), i0.ɵɵsanitizeHtml);
} }
function OfflineMessageUiComponent_div_5_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "audio", 39);
    i0.ɵɵelement(2, "source", 40);
    i0.ɵɵtext(3, " Your browser does not support the audio element. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("src", m_r5.message, i0.ɵɵsanitizeUrl);
} }
function OfflineMessageUiComponent_div_5_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "a", 41);
    i0.ɵɵelement(2, "img", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "br");
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("href", ctx_r14.getMediaDownloadUrl(m_r5), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("src", ctx_r14.getMediaDownloadUrl(m_r5), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r14.getImageCaption(m_r5));
} }
function OfflineMessageUiComponent_div_5_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 43);
} if (rf & 2) {
    const m_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", m_r5.message, i0.ɵɵsanitizeHtml);
} }
function OfflineMessageUiComponent_div_5_img_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 44);
} if (rf & 2) {
    const m_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("src", "../../../../../../../../../content/images/chat/" + m_r5.status + ".png", i0.ɵɵsanitizeUrl);
} }
function OfflineMessageUiComponent_div_5_div_17_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 37);
} }
function OfflineMessageUiComponent_div_5_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵtemplate(1, OfflineMessageUiComponent_div_5_div_17_fa_icon_1_Template, 1, 0, "fa-icon", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.isCoach() && m_r5.chosenToBeEmailed);
} }
function OfflineMessageUiComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11, 12);
    i0.ɵɵtemplate(2, OfflineMessageUiComponent_div_5_span_2_Template, 2, 1, "span", 13);
    i0.ɵɵelementStart(3, "div", 14);
    i0.ɵɵlistener("mouseenter", function OfflineMessageUiComponent_div_5_Template_div_mouseenter_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r47); const m_r5 = restoredCtx.$implicit; const ctx_r46 = i0.ɵɵnextContext(); return ctx_r46.makeVisible(m_r5.id); })("mouseleave", function OfflineMessageUiComponent_div_5_Template_div_mouseleave_3_listener() { i0.ɵɵrestoreView(_r47); const ctx_r48 = i0.ɵɵnextContext(); return ctx_r48.makeHidden(); });
    i0.ɵɵtemplate(4, OfflineMessageUiComponent_div_5_div_4_Template, 7, 4, "div", 15);
    i0.ɵɵtemplate(5, OfflineMessageUiComponent_div_5_div_5_Template, 7, 6, "div", 16);
    i0.ɵɵelementStart(6, "div", 17);
    i0.ɵɵlistener("click", function OfflineMessageUiComponent_div_5_Template_div_click_6_listener() { const restoredCtx = i0.ɵɵrestoreView(_r47); const m_r5 = restoredCtx.$implicit; const ctx_r49 = i0.ɵɵnextContext(); return ctx_r49.toggleVisible(m_r5.id); });
    i0.ɵɵtemplate(7, OfflineMessageUiComponent_div_5_div_7_Template, 2, 1, "div", 18);
    i0.ɵɵelementStart(8, "div", 19);
    i0.ɵɵtemplate(9, OfflineMessageUiComponent_div_5_div_9_Template, 1, 1, "div", 20);
    i0.ɵɵelementStart(10, "div", 21);
    i0.ɵɵtemplate(11, OfflineMessageUiComponent_div_5_div_11_Template, 4, 1, "div", 22);
    i0.ɵɵtemplate(12, OfflineMessageUiComponent_div_5_div_12_Template, 6, 3, "div", 22);
    i0.ɵɵtemplate(13, OfflineMessageUiComponent_div_5_span_13_Template, 1, 1, "span", 23);
    i0.ɵɵelementStart(14, "span", 24);
    i0.ɵɵtext(15);
    i0.ɵɵtemplate(16, OfflineMessageUiComponent_div_5_img_16_Template, 1, 1, "img", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, OfflineMessageUiComponent_div_5_div_17_Template, 2, 1, "div", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r5 = ctx.$implicit;
    const i_r6 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i_r6 === 0 || ctx_r3.dateFormatted(m_r5.createDate) !== ctx_r3.dateFormatted(ctx_r3.messages[i_r6 - 1].createDate));
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("id", m_r5.id);
    i0.ɵɵproperty("ngClass", m_r5.senderId === ctx_r3.sessionStorage.retrieve("id") ? "right" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.isVisibleMobile === m_r5.id);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.isVisible === m_r5.id);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", m_r5.senderId === ctx_r3.sessionStorage.retrieve("id"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", m_r5.replyId !== null && m_r5.replyId !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", m_r5.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "audio");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "image");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r3.timeFormatted(m_r5.createDate), " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", m_r5.status && ctx_r3.sentByCurrentUser(m_r5.senderId));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(m_r5.senderId === ctx_r3.sessionStorage.retrieve("id")));
} }
function OfflineMessageUiComponent_div_6_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 50);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r50.unreadMessageCount);
} }
function OfflineMessageUiComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r52 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelementStart(1, "button", 47);
    i0.ɵɵlistener("click", function OfflineMessageUiComponent_div_6_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r52); const ctx_r51 = i0.ɵɵnextContext(); return ctx_r51.scrollToBottom(); });
    i0.ɵɵelement(2, "fa-icon", 48);
    i0.ɵɵtemplate(3, OfflineMessageUiComponent_div_6_span_3_Template, 2, 1, "span", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r4.unreadMessageCount > 0);
} }
export class OfflineMessageUiComponent extends BaseChatUIComponent {
    constructor(eventManager, messageService, sessionStorage, accountService, trackerService, sanitizer, modalService, offlineMessageService, languageService, router, authServerProvider) {
        super(accountService, sessionStorage, trackerService, modalService, languageService, authServerProvider);
        this.eventManager = eventManager;
        this.messageService = messageService;
        this.sessionStorage = sessionStorage;
        this.accountService = accountService;
        this.trackerService = trackerService;
        this.sanitizer = sanitizer;
        this.modalService = modalService;
        this.offlineMessageService = offlineMessageService;
        this.languageService = languageService;
        this.router = router;
        this.authServerProvider = authServerProvider;
        this.messageReceived = new EventEmitter();
        this.repliedMessage = new EventEmitter();
        this.isInbox = this.router.url.includes('inbox');
        this.messageReceivedAudio = new Audio("../../../../../../../content/audio/appointed.mp3");
        this.emptyLine = '<br>'; // ENTER
        this.lastNotification = 0;
        this.currentMessageValue = '';
    }
    ngOnInit() {
        if (this.bottomScroll === true)
            this.scrollToBottom();
    }
    ngAfterViewInit() {
        this.autoScrollToBottom();
    }
    // emptyLine2 = '<div><br></div>'; // SHIFT + ENTER
    trim(innerHTML) {
        innerHTML = innerHTML.trim();
        while (innerHTML.endsWith(this.emptyLine)) {
            //
            innerHTML = innerHTML.replace(/<br>$/, '');
        }
        return innerHTML;
    }
    getStateHtml(message) {
        return this.sanitizer.bypassSecurityTrustHtml(message);
    }
    sentByCurrentUser(userId) {
        return userId === this.sessionStorage.retrieve('id');
    }
    ngOnChanges(changes) {
        console.log('ngOnChanges: ' + JSON.stringify(changes).substr(0, 100));
        if (changes.receiver) {
            this.fetchMessages();
        }
        if (this.bottomScroll === true)
            this.scrollToBottom();
    }
    fetchMessages() {
        if (!this.selectedConversation) {
            console.log("Conversation not set");
            return;
        }
        this.offlineMessageService.getMessages(this.selectedConversation.id).subscribe(messages => {
            if (messages === null || messages === void 0 ? void 0 : messages.length) {
                messages.forEach(message => this.initMessage(message));
            }
            this.messages = messages;
            this.eventManager.broadcast({ name: 'unreadConversationCount', content: {} });
            setTimeout(() => {
                console.log("set timeout 1");
                this.scrollToBottom();
            }, 1);
        });
    }
    initMessage(message) {
        if (message.replyId) {
            this.messageService.find(message.replyId).subscribe(replayedMessage => {
                message.replyMessage = replayedMessage.body;
            });
        }
        if (message.type === 'text') {
            message.message = Linkify.convertUrlAndEmailsToLink(message.message);
        }
        return message;
    }
    onMessageReceived(message) {
        this.messageReceived.emit(message);
        if (!this.receiver) {
            console.log("No conversation selected");
            return;
        }
        this.initMessage(message);
        if (message.receiverId === this.receiver.id || message.senderId === this.receiver.id) {
            this.messages.push(message);
        }
        if (!this.sentByCurrentUser(message.senderId) && message.convId === this.selectedConversation.id) {
            // console.log('Notifying sender');
            this.unreadMessageCount++;
            this.offlineMessageService.offlineMessageSeen(message.id).subscribe(() => {
            });
        }
        if (!document.hasFocus()) {
            console.log('Notifying receiver: Message from ' + message.senderId);
            let promise = this.messageReceivedAudio.play().catch(reason => {
                console.warn("Message received audio cannot be played:" + reason);
            });
        }
        else {
            console.log('No need to notify anyone. But the message is from ' + message.senderId);
        }
        setTimeout(() => {
            console.log("set timeout 2");
            // Message isn't appended immediately. Give some time to Angular to do the stuff.
            if (!this.showScrollDownIcon) {
                this.autoScrollToBottom();
            }
        }, 1);
    }
    addToMessagesEmail(m, isCoach) {
        if (!isCoach) {
            console.log('Clients can not email chat messages');
            return;
        }
        m.chosenToBeEmailed = !m.chosenToBeEmailed;
        if (this.messageService.inboxMessagesList === undefined) {
            this.messageService.inboxMessagesList = [];
        }
        console.log(this.messageService.inboxMessagesList);
        m.chosenToBeEmailed ? this.messageService.inboxMessagesList.push(m) : this.messageService.inboxMessagesList.splice(this.messageService.inboxMessagesList.indexOf(m), 1);
        this.eventManager.broadcast({ name: 'inboxMessagesList', content: this.messageService.inboxMessagesList });
    }
    getReplyMessage(replyId) {
        let iMessages = this.messages.filter(message => message.id === replyId);
        if (iMessages && iMessages.length) {
            return iMessages[0].message;
        }
        return null;
    }
    replyThisMessage(m) {
        console.log(m);
        this.repliedMessage.emit(JSON.parse(JSON.stringify(m)));
    }
    scrollToOriginal(id) {
        document.getElementById(String(id)).scrollIntoView();
    }
    updateMessageStatus(message) {
        console.log("updateMessageStatus: " + message.status);
        let iMessages = this.messages.filter((m) => m.id === message);
        iMessages[0].status = STATUS_DISPLAYED_ON_RECEIVER;
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    getStatusIcon(status) {
        let filename = status === null || status === '' ? 'DISPLAYED' : `${status}`;
        return `../../../../../../content/images/sprite.svg?v=3#${filename}`;
    }
    characterCountIndicator() {
        // if (!this.messageSendContainer) return "0/500";
        // return this.messageSendContainer?.nativeElement.innerHTML.length + "/500";
    }
    displayWelcomeMessage() {
        return false;
    }
}
OfflineMessageUiComponent.ɵfac = function OfflineMessageUiComponent_Factory(t) { return new (t || OfflineMessageUiComponent)(i0.ɵɵdirectiveInject(i1.JhiEventManager), i0.ɵɵdirectiveInject(i2.MessageService), i0.ɵɵdirectiveInject(i3.SessionStorageService), i0.ɵɵdirectiveInject(i4.AccountService), i0.ɵɵdirectiveInject(i5.TrackerService), i0.ɵɵdirectiveInject(i6.DomSanitizer), i0.ɵɵdirectiveInject(i7.NgbModal), i0.ɵɵdirectiveInject(i8.OfflineMessageService), i0.ɵɵdirectiveInject(i9.JhiLanguageService), i0.ɵɵdirectiveInject(i10.Router), i0.ɵɵdirectiveInject(i11.AuthServerProvider)); };
OfflineMessageUiComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OfflineMessageUiComponent, selectors: [["offline-message-ui"]], inputs: { receiver: "receiver", selectedConversation: "selectedConversation", bottomScroll: "bottomScroll", session: "session" }, outputs: { messageReceived: "messageReceived", repliedMessage: "repliedMessage" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 7, vars: 3, consts: [[2, "height", "100%", "overflow-y", "scroll", "overflow-x", "hidden", 3, "scroll"], ["messagesContainer", ""], ["class", "message-feed", 4, "ngIf"], ["id", "top-date", 1, "date-sticky", "badge", "badge-secondary"], ["topDate", ""], ["id", "messages", "class", "position-relative", 4, "ngFor", "ngForOf"], ["class", "position-absolute float-right", "style", "bottom: 50px; right: 50px;", 4, "ngIf"], [1, "message-feed"], [1, "px-2", "float-left"], [1, "media-body"], ["jhiTranslate", "sessionChat.paragraph.hi", 1, "mf-content", 2, "text-align", "left"], ["id", "messages", 1, "position-relative"], ["messageBox", ""], ["id", "date-sticky", "class", "date-sticky badge badge-secondary", 4, "ngIf"], [1, "message-feed", 3, "id", "ngClass", "mouseenter", "mouseleave"], ["style", "display: inline-block; text-align: right;", 4, "ngIf"], [3, "style", 4, "ngIf"], [1, "media-body", 2, "position", "relative", 3, "click"], ["class", "selected-icon selected-icon-left", 4, "ngIf"], [1, "mf-content", 2, "text-align", "left", "display", "inline-block"], ["class", "reply-div", "role", "button", "style", "font-size: 12px!important; background-color: #EEEEEE!important;", 3, "innerHTML", "click", 4, "ngIf"], [3, "ngSwitch"], [4, "ngSwitchCase"], ["class", "message-text", "inputAutoDirectionSwitch", "", 3, "innerHTML", 4, "ngSwitchDefault"], [1, "float-right", 2, "font-size", "9px!important", "margin", "15px 0 0 5px!important"], [3, "src", 4, "ngIf"], ["class", "selected-icon selected-icon-right", 4, "ngIf"], ["id", "date-sticky", 1, "date-sticky", "badge", "badge-secondary"], [2, "display", "inline-block", "text-align", "right"], [1, "d-md-none", 2, "display", "inline-block", "border", "1px solid #6c757d", "border-radius", "3px", "text-align", "right", "padding", "0 3px 0 3px"], [2, "display", "inline-block"], ["role", "button", "icon", "reply", 2, "color", "#6c757d", "font-size", "13px", 3, "title", "click"], ["role", "button", "class", "check pl-1", "icon", "envelope", "style", "color: #6c757d; font-size: 13px;", 3, "title", "click", 4, "ngIf"], ["role", "button", "icon", "envelope", 1, "check", "pl-1", 2, "color", "#6c757d", "font-size", "13px", 3, "title", "click"], [1, "d-none", "d-md-block", 2, "display", "inline-block", "border", "1px solid #6c757d", "border-radius", "3px", "text-align", "right", "padding", "0 3px 0 3px"], [1, "selected-icon", "selected-icon-left"], ["style", "padding: 3px;", "class", "check", "icon", "check", 4, "ngIf"], ["icon", "check", 1, "check", 2, "padding", "3px"], ["role", "button", 1, "reply-div", 2, "font-size", "12px!important", "background-color", "#EEEEEE!important", 3, "innerHTML", "click"], ["controls", ""], ["type", "audio/mpeg", 3, "src"], [3, "href"], [1, "img-chat", 3, "src"], ["inputAutoDirectionSwitch", "", 1, "message-text", 3, "innerHTML"], [3, "src"], [1, "selected-icon", "selected-icon-right"], [1, "position-absolute", "float-right", 2, "bottom", "50px", "right", "50px"], [1, "scroll-down", 3, "click"], ["icon", "arrow-down"], ["class", "badge badge-pill badge-primary", "style", "background-color: #44a38d; position: absolute; top: -12px; right: -12px;", 4, "ngIf"], [1, "badge", "badge-pill", "badge-primary", 2, "background-color", "#44a38d", "position", "absolute", "top", "-12px", "right", "-12px"]], template: function OfflineMessageUiComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0, 1);
        i0.ɵɵlistener("scroll", function OfflineMessageUiComponent_Template_div_scroll_0_listener() { ctx.updateScrollDownIcon(); return ctx.showCurrentDate(); });
        i0.ɵɵtemplate(2, OfflineMessageUiComponent_div_2_Template, 5, 0, "div", 2);
        i0.ɵɵelement(3, "span", 3, 4);
        i0.ɵɵtemplate(5, OfflineMessageUiComponent_div_5_Template, 18, 13, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, OfflineMessageUiComponent_div_6_Template, 4, 1, "div", 6);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.displayWelcomeMessage());
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.messages);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showScrollDownIcon);
    } }, directives: [i12.ɵc, i13.NgIf, i13.NgForOf, i14.JhiTranslateDirective, i13.NgClass, i13.NgSwitch, i13.NgSwitchCase, i13.NgSwitchDefault, i15.FaIconComponent, i16.InputAutoDirectionSwitchDirective], pipes: [i17.TranslatePipe], styles: [".message-feed.right[_ngcontent-%COMP%]{text-align:right;position:relative}.msb-reply[_ngcontent-%COMP%]{box-shadow:0 -20px 20px -5px #fff;background:#fff}.scroll[_ngcontent-%COMP%]{position:absolute;border:0;font-size:20px;color:#44a38d;height:40px;width:40px;border-radius:50%;box-shadow:2px 2px 8px -4px rgba(0,0,0,.75)}.scroll[_ngcontent-%COMP%]:hover{background-color:#fafaff}.date-sticky[_ngcontent-%COMP%]{position:sticky;position:-webkit-sticky;top:0;display:table;margin:0 auto}.img-chat[_ngcontent-%COMP%]{float:left;width:150px;height:150px;-o-object-fit:cover;object-fit:cover}.message-text[_ngcontent-%COMP%]{font-family:\"Open Sans\",sans-serif !important;font-size:14px !important;word-break:break-word}"] });
